import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierOutlinedHeartFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M11 1C3.5 1 1 6 1 11s2.5 10 10 10c2.96 0 5.142-.779 6.698-2.03l4.026 4.027 1.272-1.273-4.034-4.034C20.413 15.84 21 13.424 21 11.008h-1.8c-.001 2.23-.563 4.266-1.77 5.715C16.27 18.116 14.317 19.2 11 19.2s-5.27-1.084-6.43-2.477C3.362 15.273 2.8 13.233 2.8 11s.562-4.272 1.77-5.722C5.73 3.885 7.683 2.8 11 2.8z"
                    fill="currentColor"
                />
                <path
                    d="M13.1 4.102c0-2.25 2.864-3.223 4.5-.887 1.636-2.336 4.5-1.25 4.5.887 0 1.822-2.478 3.306-4.338 4.421l-.162.097-.162-.097c-1.86-1.115-4.338-2.6-4.338-4.42"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
MagnifierOutlinedHeartFilledSize24Glyph.displayName = 'MagnifierOutlinedHeartFilledSize24Glyph';
